// assets/js/podcast-player.js
// Player podcast auto-hébergé (Shikwasa) : yarn add shikwasa  (le projet est verrouillé sur Yarn 1, ne pas utiliser npm install)
//
// Dans l'entrée Encore (app.js) :
//   import { initPodcastPlayers } from './js/podcast-player';
//
// ⚠️ Si la page podcasts utilise le rechargement AJAX (recherche/pagination,
// bloc isXmlHttpRequest du PodcastController), rappeler initPodcastPlayers()
// après l'injection du HTML retourné, sinon les nouveaux items n'auront pas
// de player :
//   container.innerHTML = json.html;
//   initPodcastPlayers(container);
//   initPodcastDescriptions(container);

import 'shikwasa/dist/style.css';
import { Player } from 'shikwasa';

export function initPodcastPlayers(root = document) {
    root.querySelectorAll('.podcast-player:not([data-player-init])').forEach((el) => {
        // Garde-fou : évite la double initialisation du même élément
        el.dataset.playerInit = '1';

        const player = new Player({
            container: () => el,
            themeColor: '#13568f', // couleur charte podcast (cf. podcasts.css)
            // 'static' : le player reste dans le flux de la page. Le défaut 'auto'
            // le fixe en bas du viewport sur petit écran, et dans le listing
            // podcasts plusieurs players se superposeraient.
            fixed: { type: 'static' },
            audio: {
                title: el.dataset.title,
                cover: el.dataset.cover || null,
                src: el.dataset.src,
            },
        });

        addVolumeSlider(el, player);
    });
}

// Curseur de volume : Shikwasa n'a qu'un bouton muet. On insère un <input type="range">
// après ce bouton, relié au volume de l'élément audio du lecteur. Le bouton muet et le
// curseur restent synchronisés via l'événement volumechange. Masqué sur mobile par le
// CSS (iOS ignore le volume logiciel).
function addVolumeSlider(el, player) {
    const volumeBtn = el.querySelector('.shk-btn_volume');
    if (!volumeBtn || !player.audio) return;

    const slider = document.createElement('input');
    slider.type = 'range';
    slider.min = '0';
    slider.max = '1';
    slider.step = '0.05';
    slider.className = 'podcast-volume';
    slider.setAttribute('aria-label', 'Volume');

    const render = () => {
        const v = player.muted ? 0 : player.audio.volume;
        slider.value = String(v);
        slider.style.setProperty('--podcast-volume', `${Math.round(v * 100)}%`);
    };

    slider.addEventListener('input', () => {
        const v = parseFloat(slider.value);
        player.audio.volume = v;
        if (v > 0 && player.muted) player.muted = false;
        if (v === 0 && !player.muted) player.muted = true;
        render();
    });
    player.audio.addEventListener('volumechange', render);

    volumeBtn.insertAdjacentElement('afterend', slider);
    render();
}

// Description repliée sur 3 lignes (CSS) : quand le texte tient dans la boîte,
// on masque le lien "Voir plus" en posant .is-short. Mesuré après le chargement
// des polices, sinon le nombre de lignes peut encore changer.
export function initPodcastDescriptions(root = document) {
    root.querySelectorAll('.podcast-description:not([data-description-init])').forEach((el) => {
        el.dataset.descriptionInit = '1';
        const text = el.querySelector('.podcast-description-text');
        if (text && text.scrollHeight <= text.clientHeight + 1) {
            el.classList.add('is-short');
        }
    });
}

document.addEventListener('DOMContentLoaded', () => {
    initPodcastPlayers();
    const fontsReady = document.fonts ? document.fonts.ready : Promise.resolve();
    fontsReady.then(() => initPodcastDescriptions());
});
